import { render, staticRenderFns } from "./ProcedimentoFormulario.vue?vue&type=template&id=158d4813&scoped=true"
import script from "./ProcedimentoFormulario.vue?vue&type=script&lang=js"
export * from "./ProcedimentoFormulario.vue?vue&type=script&lang=js"
import style0 from "./ProcedimentoFormulario.vue?vue&type=style&index=0&id=158d4813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d4813",
  null
  
)

export default component.exports